import { View, Heading, Text, Divider, Flex, Badge, Link } from "@aws-amplify/ui-react"; // Linkを追加
import SubscriptionPortal from './SubscriptionPortal';
// 定数のインポートを追加
import { TERMS_OF_USE_PATH, MAPPLE_COM_LINKS } from "../../constants/Constant";

const ActiveView = () => (
  <View padding="0.5rem">
    {/* ヘッダーセクション */}
    <Flex direction="row" alignItems="center" marginBottom="1rem" gap="1rem">
      <Heading level={5}>ご利用中のサービス: サブスクリプション（有料会員）</Heading>
      <Badge variation="success">アクティブ</Badge>
    </Flex>

    <Text marginBottom="1.5rem" variation="tertiary" fontSize="0.9rem">
      現在、MAPPLE法務局地図ビューアのサブスクリプションの機能（地図印刷・画像作成等）をご利用いただけます。
    </Text>

    <Divider size="small" marginBottom="1.5rem" />

    {/* ポータル案内セクション */}
    <Heading level={6} marginBottom="0.8rem">
      お支払い情報の管理・解約受付
    </Heading>
    
    <Text marginBottom="1rem">
      決済サービス「Stripe」のカスタマーポータルにて、以下が可能です。
    </Text>

    <View as="ul" marginBottom="1.5rem" paddingLeft="1.5rem">
      <Text as="li" fontSize="0.9rem" marginBottom="0.4rem">登録したクレジットカードの確認・変更</Text>
      <Text as="li" fontSize="0.9rem" marginBottom="0.4rem">サブスクリプションの請求書・領収書の表示・ダウンロード</Text>
      <Text as="li" fontSize="0.9rem" marginBottom="0.4rem">サブスクリプションの解約受付・解約受付の取り消し</Text>
    </View>

    <Text marginBottom="1.5rem" variation="warning" fontSize="0.85rem">
      ※解約受付後も、現在の期間終了までは引き続きサブスクリプションをご利用いただけます。
    </Text>

    {/* 追加箇所：サポート・お問い合わせセクション */}
    <Divider size="small" marginBottom="1.5rem" />
    <Heading level={6} marginBottom="0.8rem">
      サポート・お問い合わせ
    </Heading>
    <Text marginBottom="1rem" fontSize="0.9rem">
      本サービスに関するご質問などは、
      <Link href={MAPPLE_COM_LINKS.CONTACT_SITE} isExternal={true} color="#007bff">
        お問い合わせフォーム
      </Link>
      よりご連絡ください。
    </Text>
    <Text marginBottom="1.5rem" variation="tertiary" fontSize="0.85rem">
      お問い合わせへの回答は、平日 10:00〜17:00 とさせていただいております。<br />
      （土・日・祝日、年末年始、および当社指定の休業日を除きます。）
    </Text>

    {/* 規約・詳細説明へのリンク */}
    <View marginBottom="1.5rem" padding="0.5rem" backgroundColor="#f0f4f8" borderRadius="4px">
      <Text fontSize="0.8rem" textAlign="center" lineHeight="1.5">
        サブスクリプションについて<br />
        <Link href={MAPPLE_COM_LINKS.SUBSCRIPTION_NEWS} isExternal={true} fontWeight="bold">
          サブスクリプションの詳細説明
        </Link>
        {" ／ "}
        <Link href={TERMS_OF_USE_PATH} isExternal={true} fontWeight="bold">
          アカウント利用規約
        </Link>
      </Text>
    </View>

    {/* ボタンセクション */}
    <div className="d-grid gap-2">
      <SubscriptionPortal />
    </div>
  </View>
);

export default ActiveView;